<ng-container *ngIf="participants.length > 0; else noParticipant">
    <adapt-link-person *ngFor="let participant of participants"
                       [person]="participant"
                       [imageOnly]="true"></adapt-link-person>
</ng-container>
<ng-template #noParticipant>
    <p>This meeting has no attendees</p>
</ng-template>
